import ArrowForward from '@mui/icons-material/ArrowForward';

import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import CardMedia from '@zenbusiness/zui/CardMedia';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import { BASE_STYLES } from '../utils/constants';

export const StandaloneToolCard = superstyled({
  name: 'StandaloneToolCard',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    ...BASE_STYLES,
    padding: theme.spacing(0),
    borderRadius: theme.shape.rounded.xl,
    overflow: 'hidden'
  })
});

export const ImageContainer = superstyled({
  name: 'StandaloneToolCard',
  slot: 'ImageContainer',
  tag: CardMedia,
  propsAdded: {
    component: 'figure'
  },
  styles: () => ({
    position: 'relative',
    height: '12.5rem',
    width: '100%',
    margin: 0,
    overflow: 'hidden'
  })
});

export const Thumbnail = superstyled({
  name: 'StandaloneToolCard',
  slot: 'Thumbnail',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderTopLeftRadius: theme.shape.rounded.xl,
    borderTopRightRadius: theme.shape.rounded.xl
  })
});

export const Icon = superstyled({
  name: 'StandaloneToolCard',
  slot: 'Icon',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    width: '4rem',
    height: '4rem',
    objectFit: 'contain',
    position: 'absolute',
    backgroundColor: theme.palette.background.grey.main,
    padding: theme.spacing(1),
    borderRadius: theme.shape.rounded.md,
    top: '10rem',
    left: theme.spacing(3),
    boxShadow: theme.shadows[2],
    zIndex: 1
  })
});

export const Content = superstyled({
  name: 'StandaloneToolCard',
  slot: 'Content',
  tag: CardContent,
  styles: ({ theme }) => ({
    padding: theme.spacing(4.5, 3, 3, 3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  })
});

export const Title = superstyled({
  name: 'StandaloneToolCard',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary
  })
});

export const Subtitle = superstyled({
  name: 'StandaloneToolCard',
  slot: 'Subtitle',
  tag: Text,
  styles: () => ({})
});

export const CtaButton = superstyled({
  name: 'StandaloneToolCard',
  slot: 'CtaButton',
  tag: Button,
  styles: () => ({})
});

export const ArrowForwardIcon = superstyled({
  name: 'StandaloneToolCard',
  slot: 'ArrowForwardIcon',
  tag: ArrowForward,
  styles: ({ theme }) => ({
    marginLeft: theme.spacing(0.5),
    color: theme.palette.secondary.main,
    transition: 'transform 0.3s ease',
    '.MuiButton-root:hover &': {
      transform: 'translateX(6px)'
    }
  })
});

export const TextHighlight = superstyled({
  name: 'StandaloneToolCard',
  slot: 'TextHighlight',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.secondary.main,
    fontWeight: 600
  })
});
